import React, { FC, ReactNode } from "react";
import cn from "classnames";

interface Props {
  children: ReactNode;
  className?: string;
}

export const NoResultsMessage: FC<Props> = ({ children, className }) => {
  return (
    <div
      className={cn(
        "text-center p-5 border border-black-base/20 rounded-20",
        className
      )}
    >
      {children}
    </div>
  );
};
